import type { ComponentProps, ReactElement } from 'react';
import { cn } from './utils';

/**
 * Der Platzhalter aus shadcn/ui, wörtlich übernommen bis auf `bg-accent` →
 * `bg-secondary`. Das ist keine Geschmacksfrage: `--muted` ist im Hellen
 * `slate-100` und misst auf der weissen Karte 1,11:1 — ein Platzhalter, den
 * man nicht sieht, ist keiner. `--secondary` ist `slate-200` beziehungsweise
 * `slate-800` und steht in beiden Fassungen sichtbar auf seiner Karte.
 *
 * **Er ERSETZT die Zeile «wird geladen …» nicht, er steht darunter.** Der Satz
 * bleibt, weil er das Einzige ist, was ein Vorleseprogramm melden kann — ein
 * graues Rechteck hat keinen zugänglichen Namen. Was der Platzhalter dazutut,
 * ist die Zusage über die FORM dessen, was gleich kommt: Die Liste springt
 * beim Eintreffen nicht mehr von einer Zeile auf zehn, und wer den Blick schon
 * auf die dritte Zeile gerichtet hat, findet sie dort wieder.
 */
function Skeleton({ className, ...props }: ComponentProps<'div'>): ReactElement {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-secondary', className)}
      {...props}
    />
  );
}

export { Skeleton };
